import "./Home.module.css";
import SiteHeader from "@/reusable_sections/Header";
import PremierCleaningExcellence from "./sections/PremierCleaningExcellence";
import CleaningExcellenceSuite from "./sections/CleaningExcellenceSuite";
import TheGoldStandardDifference from "./sections/TheGoldStandardDifference";
import Services from "./sections/Services";
import SectorsWeTransform from "./sections/SectorsWeTransform";
import ExecutiveClientPraise from "./sections/ExecutiveClientPraise";
import ServiceAreas from "./sections/ServiceAreas";
import SecureYourConsultation from "./sections/SecureYourConsultation";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteHeader />
      <PremierCleaningExcellence />
      <CleaningExcellenceSuite />
      <TheGoldStandardDifference />
      <Services />
      <SectorsWeTransform />
      <ExecutiveClientPraise />
      <ServiceAreas />
      <SecureYourConsultation />
      <SiteFooter />
    </div>;
}